import React, {useEffect, useMemo} from "react";
import {Drawer} from "antd";
import css from "./drawer.module.less";
import {getString} from "../../index";
import {openUrlInNewTab} from "../../utils";

export enum DrawerContentType {
    list,
    connect,
    inviteCode,
    humanService
}

const CommonQuestionModal = (props: any) => {
    const {modalVisible, setModalVisible, modalHeight} = props;
    /**
     * modal内容有三种
     */
    const [showContentType, setShowContentType] = React.useState(DrawerContentType.list);

    useEffect(() => {
        if (!modalVisible) {
            setShowContentType(DrawerContentType.list);
        }
    }, [modalVisible]);

    const title = useMemo(() => {
        return (
            <div className={css.helpModalWrap}>
                <div className={css.helpModalTitle}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <img className={css.closeImg} style={{marginRight: 5}}
                             src={require("../../images/question.png")} alt="question_icon"/>
                        <span>{getString("download_drawer_title")}</span>
                    </div>
                    <img onClick={() => setModalVisible(false)} className={css.closeImg}
                         src={require("../../images/close.png")} alt={""}/>
                </div>
            </div>
        )
    }, []);

    const inviteCodeView = useMemo(() => {
        return (
            <div className={`${css.content} ${css.padding}`}>
                <div>
                    <span className={css.accentText}>
                        {getString("download_drawer_tip2")}
                    </span>
                </div>

                <div style={{marginTop: 15}}>
                    <span className={css.lightText}>
                    {getString("download_drawer_invite_code_issue")}
                </span>
                </div>

                <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: 30}}>
                    <div className={css.button} onClick={() => {
                        setShowContentType(DrawerContentType.humanService)
                    }}>
                    <span>
                        {getString("download_drawer_button_human_service")}
                    </span>
                    </div>
                </div>
            </div>
        )
    }, []);

    const connectIssueView = useMemo(() => {
        return (
            <div className={`${css.content} ${css.padding}`}>
                <div>
                    <span className={css.accentText}>
                        {getString("download_drawer_tip1")}
                    </span>
                </div>

                <div style={{marginTop: 15}}>
                    <span className={css.lightText}>
                    {getString("download_drawer_connect_issue")}
                </span>
                </div>

                <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: 30}}>
                    <div className={css.button} onClick={() => {
                        openUrlInNewTab("https://shimo.im/docs/JgpJKqgwJg6CYv8C/");
                    }}>
                    <span style={{color: "#2C75FF"}}>
                        {getString("download_drawer_button_acquire_id")}
                    </span>
                    </div>

                    <div className={css.button} style={{marginTop: 20}} onClick={() => {
                        setShowContentType(DrawerContentType.humanService)
                    }}>
                    <span>
                        {getString("download_drawer_button_human_service")}
                    </span>
                    </div>
                </div>
            </div>
        )
    }, []);

    const humanServiceView = useMemo(() => {
        return (
            <div className={`${css.content} ${css.padding}`}>
                <div>
                    <span className={css.accentText}>
                        {getString("download_drawer_button_human_service_title")}
                    </span>
                </div>

                <div style={{marginTop: 15}}>
                    <span className={css.lightText}>
                    {getString("download_drawer_button_human_service_desc")}
                </span>
                </div>

                <div style={{marginTop: 15, display: "flex", justifyContent: "center"}}>
                    <img src={require("../../images/ic_qrcode_download.png")} alt={""}/>
                </div>
            </div>
        )
    }, []);

    const issueListView = useMemo(() => {
        return (
            <div className={css.content}>
                <div className={css.row} onClick={() => {
                    setShowContentType(DrawerContentType.connect)
                }}>
                    <div className={css.questionItemText}>
                        {getString("download_drawer_tip1")}
                    </div>
                    <img className={css.rightArrowIcon} src={require("../../images/right_arrow.png")}
                         alt="arrow_icon"/>
                </div>

                <div className={css.divider}/>
                <div className={css.row} onClick={() => {
                    setShowContentType(DrawerContentType.inviteCode)
                }}>
                    <div className={css.questionItemText}>
                        {getString("download_drawer_tip2")}
                    </div>
                    <img className={css.rightArrowIcon} src={require("../../images/right_arrow.png")}
                         alt="arrow_icon"/>
                </div>
                <div className={css.divider}/>
            </div>
        );
    }, []);

    const renderContentView = useMemo(() => {
        if (showContentType === DrawerContentType.list) {
            return issueListView;
        } else if (showContentType === DrawerContentType.connect) {
            return connectIssueView;
        } else if (showContentType === DrawerContentType.inviteCode) {
            return inviteCodeView;
        } else {
            return humanServiceView;
        }
    }, [showContentType, issueListView, connectIssueView, humanServiceView, inviteCodeView]);

    return (
        <Drawer
            className={css.root}
            title={title}
            placement={"bottom"}
            closable={false}
            destroyOnClose={true}
            onClose={() => setShowContentType(DrawerContentType.list)}
            height={400}
            visible={modalVisible}
            key={"bottom"}
        >
            {renderContentView}
        </Drawer>
    )
};

export default CommonQuestionModal
